import React from 'react'
import IntervalQuizSequencer from './IntervalQuizSequencer'

interface Props {}

function EduIntervalQuizPage(props: Props) {
  // const {} = props

  // TODO quiz sequencer should be generic obviously
  return (
    <IntervalQuizSequencer />
  )
}

export default EduIntervalQuizPage
